module.exports = __webpack_public_path__ + "img/mirrors_edge.a9c8d0f3.jpg";